import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import i18 from '../../../i18'
import PATH from '../../../config/dev'
import Summarization from './summarization'
import {Link} from 'react-router-dom'
import api from '../../../source/api';
import User from "../../../helpers/user";


class Download extends Reflux.Component {

    constructor(props) {
        super(props)
        this.state = {
            disableDownloadButton: false,
            files: props.files,
            totalSummarization: props.totalSummarization,
            summarization: props.summarization,
            company_id: props.location.match.params.id,
            step: props.currentStep
        }
        this.store = Store
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            files: nextProps.files,
            summarization: nextProps.summarization,
            totalSummarization: nextProps.totalSummarization,
        })
    }

    downloadOutputXml = () => {
        if (!this.state.files) {
            this.props.notifyError('Kimeneti fájl generálása sikertelen.')
            return
        }

        setTimeout(() => {
            var win = window.open(PATH.ENDPOINT_BASE_URL + 'cashregister/download'
                + '?api_token=' + User.requireUser().auth_key
                + '&company_id=' + this.state.company_id
                + '&name=' + this.state.files
            );
            win.onbeforeunload = () => {
                this.setState({disableDownloadButton: true})
            }
        }, 1500)
    }

    printPage = () => {
        window.print()
    }


    downloadAsExcel = () => {
        let payload = {
            summarization: this.state.summarization,
            totalSummarization: this.state.totalSummarization,
            company_id: this.state.company_id
        }
        api.post('cashregister/generatesummarizationexcel', payload)
            .then(response => {
                let file = response.data.file
                setTimeout(() => {
                    window.open(PATH.ENDPOINT_BASE_URL + 'cashregister/download/excel'
                        + '?api_token=' + User.requireUser().auth_key
                        + '&company_id=' + this.state.company_id
                        + '&name=' + file
                    )
                }, 1500)
            })
            .catch((err) => {
                alert('Hiba történt feldolgozás közben.')
            })
    }

    render() {
        return (
            <div className='col-12'>
                <br/>
                <br/>
                <h4>{i18.COMMON._processedSuccessfully}</h4>
                <br/>
                <a className={this.state.disableDownloadButton ? 'd-none' : 'link-color'} onClick={() => this.printPage()}><i className="fa fa-print" aria-hidden="true"></i>&nbsp;Összesítő táblázat nyomtatása</a><br/>
                <a className={this.state.disableDownloadButton ? 'd-none' : 'link-color'} onClick={() => this.downloadAsExcel()}><i className="fa fa-file-excel-o" aria-hidden="true"></i>&nbsp;Összesítő táblázat letöltése</a>
                <div className='text-center'>
                    <a onClick={() => this.downloadOutputXml()} className={this.state.disableDownloadButton ? 'd-none' : 'green-btn uppercase'}>{i18.BUTTONS._downloadOutputFile}</a>&nbsp;&nbsp;
                    <a className={this.state.disableDownloadButton ? 'green-btn uppercase disabled' : 'd-none'}>{i18.BUTTONS._downloadOutputFile}</a>&nbsp;&nbsp;
                </div>
                <div className='text-center'>
                    <br/>
                    <br/>
                    <Link to="/" className={this.state.disableDownloadButton ? '' : 'd-none'}>Új feldolgozás indítása</Link>
                </div>
                <div className='row'>
                    <Summarization totalSummarization={this.state.totalSummarization} summarization={this.state.summarization}/>
                </div>
                <br/>
                <br/>
            </div>
        )
    }
}

export default Download


// WEBPACK FOOTER //
// ./src/components/cashregister/steps/download.js